<template>
  <div class="track-container">
    <search :model="formModel" @replay="search" :loading="loading" :deviceModelBusiType="999" />
    <m-table
      i18n-path="query"
      :loading="loading"
      :tableData="hisData"
      :tableColumn="tableColumn"
      :oprateMenu="oprateMenu"
      :pagiOption="pagiOption"
      v-on:search="search"
    ></m-table>
  </div>
</template>

<script>
import { getReplayList } from '@/api/track';
import Search from './components/search';
import MTable from '@/components/mTable/m-table';
// import ctt from '@/utils/const';
import { formatTime, getTime, toTimestamp } from '@/utils/date';
import { validParamObject } from '@/utils/validator';

export default {
  name: 'trackReplayList',
  components: { Search, MTable },
  props: {
    sn: String,
    deviceType: String
  },
  data() {
    const { beginTime, endTime } = this.$route.query;
    const now = Date.now();
    const begin = toTimestamp(beginTime || now - getTime('d'));
    const end = toTimestamp(endTime || now);
    return {
      hisData: [],
      loading: true,
      formModel: {
        sn: this.sn ? [this.sn] : [],
        officeId: [],
        rangeDateVal: [begin, end]
      },
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        // { label: '设备名称', prop: 'deviceName' },
        // { label: '设备类型', prop: 'deviceTypeName' },
        {
          label: '开始时间',
          prop: 'beginTime',
          temp: scope => {
            return `<span>${formatTime(scope.row.beginTime)}</span>`;
          }
        },
        {
          label: '结束时间',
          prop: 'endTime',
          temp: scope => {
            return `<span>${formatTime(scope.row.endTime)}</span>`;
          }
        }
      ],
      oprateMenu: {
        label: '操作',
        list: [
          {
            text: '回放',
            access: () => {
              return true;
            },
            event: (_, data) => {
              let { officeId, beginTime, endTime, id, sn } = data;
              this.$router.push({
                name: 'trackReplayDetails',
                query: {
                  officeId,
                  beginTime,
                  endTime,
                  id,
                  sn
                }
              });
            }
          }
        ]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      }
    };
  },
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;
      const param = {
        officeId: formModel.officeId[0],
        sns: formModel.sn,
        speed: formModel.speed,
        limit: pagiOption.limit,
        offset: pagiOption.offset,
        beginTime: formModel.rangeDateVal && formModel.rangeDateVal[0],
        endTime: formModel.rangeDateVal && formModel.rangeDateVal[1]
      };
      return validParamObject(param);
    }
  },
  methods: {
    async search() {
      try {
        this.loading = true;
        const res = await getReplayList(this.comParams);
        this.hisData = res.data.list;
        this.pagiOption.total = res.data.total;
      } finally {
        this.loading = false;
      }
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.hisData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    }
  },
  watch: {
    sn: {
      handler(n, o) {
        if (n !== o) this.resetSearch();
        this.search();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.track-container {
  box-sizing: border-box;
}
</style>
